export default "__VITE_ASSET__Cbi4p7eM__"